export default "__VITE_ASSET__f61b5ce0__"